module.exports = __webpack_public_path__ + "img/nuclear-plant.8d7dc331.jpg";